module.exports = __webpack_public_path__ + "static/who-we-help-school-3b06291f62c2bb3a8d1e42735b8f9833.jpg";